import {RootState} from "../../../../store";

export const getChatsIsLoadingChat = (state: RootState) => state.chatsReducer.isLoadingChat;
